import React, { forwardRef, useImperativeHandle } from 'react';
import { Table } from '@ajaibid/components';

import stockService from '@services/stock';

import OrderActionProvider from '../components/OrderActionProvider';

import Detail from './components/Detail';
import useColumns from './hooks/useColumns';
import { styTable, styWrapper } from './style';

function getRowId(row, ix, parent) {
  return `${parent ? `${parent?.order_no}__` : ''}${row?.order_no || ix}`;
}

function renderRowExpand(row) {
  return <Detail item={row.original} />;
}

const StockOrderRegular = forwardRef((_, ref) => {
  const { data, isInitialLoading, refetch, isRefetching, fetchNextPage, isFetchingNextPage } =
    stockService.order.open.regular.list.useList();

  const columns = useColumns();

  useImperativeHandle(ref, () => ({
    // Allow the following functions & variables to be called from its parents
    refetchTable: refetch,
    isRefetching,
  }));

  return (
    <OrderActionProvider>
      <div className={styWrapper}>
        <Table
          data-testid="tbl-regularOrder"
          className={styTable}
          data={data}
          columns={columns}
          options={{ isHeaderVisible: true, isRowExpandable: true }}
          fetchNext={fetchNextPage}
          getRowId={getRowId}
          isInitialLoading={isInitialLoading}
          isFetchingNext={isFetchingNextPage}
          renderRowExpand={renderRowExpand}
          emptyStateContent="Mulai bertransaksi dan lihat statusnya di sini."
        />
      </div>
    </OrderActionProvider>
  );
});

export default StockOrderRegular;
